import PropTypes from 'prop-types'

/**
 * @typedef {Object} TpmsAlarmConfiguration
 * @property {number} catastrophic
 * @property {number} critical
 * @property {number} warning
 */
export const tpmsAlarmConfigurationPropType = PropTypes.shape({
    catastrophic: PropTypes.number,
    critical: PropTypes.number,
    warning: PropTypes.number
})
